// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorState_wrapper__0_KRu","content":"ErrorState_content__BbGNJ"};